export const LearningCoursesIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_464_3619)">
        <path
          d="M12.928 17.9857C12.5118 17.8412 12.3451 17.5484 12.3832 17.1135C12.4098 16.8142 12.4074 16.512 12.4176 16.2126L12.4148 16.2151C12.7777 16.22 13.1402 16.2241 13.5032 16.2306C13.5765 16.2306 13.6494 16.2425 13.7224 16.2486L13.7191 16.245C13.7109 16.5357 13.6851 16.8269 13.6986 17.1164C13.7187 17.5517 13.5618 17.8535 13.1325 17.987L12.928 17.9857Z"
          fill={color}
        />
        <path
          d="M13.6942 10.9382C13.6942 10.749 13.6942 10.5795 13.6942 10.41C13.6971 10.3044 13.6778 10.1994 13.6375 10.1017C13.5972 10.0041 13.5368 9.916 13.4603 9.84321C12.467 8.85332 11.4747 7.86247 10.4833 6.87066C10.1892 6.57787 9.78446 6.56927 9.51901 6.84036C9.25356 7.11145 9.27076 7.50375 9.56899 7.80268C10.4585 8.69402 11.3499 9.58372 12.2432 10.4718C12.3493 10.577 12.3976 10.6806 12.3894 10.8297C12.3743 11.1135 12.4714 11.4542 12.3423 11.6667C12.2133 11.8792 11.8712 11.9615 11.6258 12.1069C11.1511 12.3887 10.6525 12.586 10.0901 12.6008C9.56364 12.6185 9.04233 12.4925 8.58214 12.2363C6.19523 10.9169 3.80805 9.59819 1.4206 8.28015C0.91796 8.00211 0.615638 7.5922 0.617686 7.00211C0.620144 6.42021 0.923285 6.01522 1.41692 5.74249C3.81529 4.41626 6.21517 3.09222 8.61655 1.77036C9.51041 1.28142 10.4383 1.272 11.3329 1.76012C13.7567 3.0828 16.1737 4.41708 18.5838 5.76297C19.6079 6.3334 19.6333 7.65649 18.6194 8.23347C17.0189 9.14542 15.3992 10.0222 13.7843 10.9149C13.755 10.9253 13.7249 10.9331 13.6942 10.9382Z"
          fill={color}
        />
        <path
          d="M12.4178 16.2113C12.3358 16.217 12.2539 16.2281 12.1748 16.2281C10.3093 16.2281 8.44347 16.2281 6.57737 16.2281C4.86461 16.2281 3.53775 15.1044 3.26124 13.4201C3.23931 13.2651 3.22945 13.1086 3.23174 12.9521C3.22888 12.129 3.23174 11.3055 3.23174 10.482C3.23174 10.4279 3.23666 10.3743 3.24116 10.2854C3.33457 10.3354 3.40994 10.3743 3.48409 10.4156C5.08624 11.2985 6.67691 12.2027 8.29381 13.0569C9.40683 13.6449 10.5571 13.613 11.6886 13.0614C11.9127 12.9521 12.1286 12.8259 12.3879 12.6867V12.9345C12.3879 13.9552 12.3879 14.9759 12.3879 15.9967C12.3919 16.0694 12.4008 16.1418 12.4145 16.2133L12.4178 16.2113Z"
          fill={color}
        />
        <path
          d="M13.7225 16.2474C13.7092 16.1816 13.7003 16.115 13.6959 16.048C13.6959 14.7425 13.6926 13.437 13.6992 12.1316C13.6992 12.0538 13.7463 11.9387 13.8073 11.9047C14.7495 11.3748 15.6962 10.8551 16.6425 10.3339C16.6701 10.3223 16.6986 10.3129 16.7277 10.306C16.7322 10.3711 16.7392 10.4235 16.7392 10.4755C16.7392 11.3052 16.7466 12.1348 16.7392 12.9645C16.7212 14.6389 15.5565 15.9583 13.895 16.1995C13.8359 16.2109 13.7775 16.2256 13.7201 16.2433L13.7225 16.2474Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_464_3619">
          <rect
            width="18.7498"
            height="18.7498"
            fill="white"
            transform="translate(0.617676 0.617562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LearningVideoIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.883021C0 0.395341 0.395511 -1.43051e-06 0.883022 -1.43051e-06H15.117C15.6046 -1.43051e-06 16 0.39551 16 0.883021V15.117C16 15.6046 15.6045 16 15.117 16H0.883022C0.395342 16 0 15.6045 0 15.117V0.883021ZM1.77778 1.77778V14.2222H14.2222V1.77778H1.77778ZM6.77502 4.81297L11.1118 7.70418C11.2752 7.81307 11.3194 8.03387 11.2104 8.19724C11.1844 8.23627 11.1508 8.26978 11.1118 8.29582L6.77502 11.187C6.61164 11.296 6.39084 11.2518 6.28196 11.0884C6.24302 11.03 6.22222 10.9614 6.22222 10.8912V5.10881C6.22222 4.91243 6.38142 4.75325 6.57778 4.75325C6.648 4.75325 6.71662 4.77402 6.77502 4.81297Z"
        fill={color}
      />
    </svg>
  );
};

export const LearningAudioIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3C5.68629 3 3 5.68629 3 9H5.25C6.07843 9 6.75 9.67155 6.75 10.5V14.25C6.75 15.0784 6.07843 15.75 5.25 15.75H3C2.17157 15.75 1.5 15.0784 1.5 14.25V9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9V14.25C16.5 15.0784 15.8285 15.75 15 15.75H12.75C11.9216 15.75 11.25 15.0784 11.25 14.25V10.5C11.25 9.67155 11.9216 9 12.75 9H15C15 5.68629 12.3137 3 9 3ZM3 10.5V14.25H5.25V10.5H3ZM12.75 10.5V14.25H15V10.5H12.75Z"
        fill={color}
      />
    </svg>
  );
};

export const LearningContentIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2222 15.7795H0.777778C0.348227 15.7795 0 15.4313 0 15.0017V1.00173C0 0.57218 0.348227 0.223953 0.777778 0.223953H13.2222C13.6518 0.223953 14 0.57218 14 1.00173V15.0017C14 15.4313 13.6518 15.7795 13.2222 15.7795ZM12.4444 14.224V1.77951H1.55556V14.224H12.4444ZM3.11111 3.33506H6.22222V6.44618H3.11111V3.33506ZM3.11111 8.00173H10.8889V9.55729H3.11111V8.00173ZM3.11111 11.1128H10.8889V12.6684H3.11111V11.1128ZM7.77778 4.11284H10.8889V5.6684H7.77778V4.11284Z"
        fill={color}
      />
    </svg>
  );
};

export const LearningInfoIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99985 0.75L4.5 8.25H13.5L8.99985 0.75ZM8.99985 3.66547L10.8507 6.75H7.14924L8.99985 3.66547ZM5.0625 15C3.92341 15 3 14.0766 3 12.9375C3 11.7984 3.92341 10.875 5.0625 10.875C6.20158 10.875 7.125 11.7984 7.125 12.9375C7.125 14.0766 6.20158 15 5.0625 15ZM5.0625 16.5C7.03001 16.5 8.625 14.9051 8.625 12.9375C8.625 10.9699 7.03001 9.375 5.0625 9.375C3.09499 9.375 1.5 10.9699 1.5 12.9375C1.5 14.9051 3.09499 16.5 5.0625 16.5ZM11.25 11.625V14.625H14.25V11.625H11.25ZM9.75 16.125V10.125H15.75V16.125H9.75Z"
        fill={color}
      />
    </svg>
  );
};

export const LearningPresentIcon = ({ color = "#8B3F9E" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 13.5V15H12.75V16.5H5.25V15H8.25V13.5H2.25C1.83579 13.5 1.5 13.1642 1.5 12.75V3C1.5 2.58579 1.83579 2.25 2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V12.75C16.5 13.1642 16.1642 13.5 15.75 13.5H9.75ZM3 3.75V12H15V3.75H3ZM7.5 5.625L11.25 7.875L7.5 10.125V5.625Z"
        fill={color}
      />
    </svg>
  );
};
